import FinishStep from './FinishStep';
import UploadStep from './UploadStep';
import ValidationStep from './ValidationStep';

export default {
  title: 'Seguidores',
  steps: {
    upload: 'Subir',
    validate: 'Confirmar',
    finish: 'Hecho',
  },
  labels: {
    import: 'Importar',
  },

  FinishStep,
  UploadStep,
  ValidationStep,
};
